import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoginService, UserDetails } from '@services/login.service';
import { LogService } from '@services/log.service';

@Component({
  selector: 'app-profile-page',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss']
})
export class ProfilePageComponent implements OnInit {
  private loginService = inject(LoginService);
  private logService = inject(LogService);
  
  isLoading = false;

  ngOnInit(): void {
    // Log page view
    this.logService.logPageView('profile', {});
  }

  get userDetails(): UserDetails | null {
    return this.loginService.loginUser;
  }

  get profileData() {
    const user = this.userDetails;
    if (!user) return [];
    
    return [
      { label: 'First Name', value: user.firstName, icon: 'person' },
      { label: 'Last Name', value: user.lastName, icon: 'person' },
      { label: 'Email Address', value: user.email, icon: 'email' },
      { label: 'Phone Number', value: user.phone || 'Not provided', icon: 'phone' },
      { label: 'Company Name', value: user.companyName || 'Not provided', icon: 'business' },
      { label: 'Company ID', value: user.companyId || 'Not provided', icon: 'badge' },
      { label: 'Role', value: user.role || 'Not specified', icon: 'work' },
      { label: 'Verification Status', value: user.isVerified ? 'Verified' : 'Not Verified', icon: user.isVerified ? 'verified' : 'warning' }
    ];
  }
}
